import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface IndicationState {
  indication: {
    quiz: boolean;
    assignment : boolean;
    myLibary : boolean;
    chat : boolean;
    live: boolean;
  };
  tabIndication: boolean
  chatTabIndication : boolean
}

const initialState: IndicationState = {
  indication: {
    quiz: false,
    assignment: false,
    myLibary : false,
    chat : false,
    live: false
  },
  tabIndication : false,
  chatTabIndication : false
};

const indicationSlice = createSlice({
  name: "indication",
  initialState,
  reducers: {
    setIndication(state, action: PayloadAction<Partial<{ quiz: boolean; assignment: boolean; myLibray: boolean; chat : boolean, live: boolean }>>) {
      if (action.payload.quiz !== undefined) {
        state.indication.quiz = action.payload.quiz;
      }
      if (action.payload.assignment !== undefined) {
        state.indication.assignment = action.payload.assignment;
      }
      if(action.payload.myLibray !== undefined){
        state.indication.myLibary = action.payload.myLibray;
      }
      if(action.payload.chat !== undefined){
        state.indication.chat = action.payload.chat;
      }
      if(action.payload.live !== undefined){
        state.indication.live = action.payload.live;
      }
    },
    setTabIndication(state, action: PayloadAction<boolean>) {
      state.tabIndication = action.payload;
    },
    setChatTabIndication(state, action: PayloadAction<boolean>) {
      state.chatTabIndication = action.payload;
    },
  },
});

export const { setIndication, setTabIndication, setChatTabIndication } = indicationSlice.actions;

export default indicationSlice.reducer;
